import React from 'react'
import './Contact.css'
import photo from '../../../assets/m2c.png'

const Contact = () => {
  return (
     <section className="contact-container">
      {/* Hero Section */}
      <div className="contact-hero">
        <div className="contact-overlay"></div>
        <div className="contact-hero-text">
          <h1>Contact Us</h1>
          <p>We’d love to hear from you — let’s make something impactful together.</p>
        </div>
      </div>

      {/* Contact Content */}
      <div className="contact-content">
        {/* Left: Form */}
        <div className="contact-left">
          <h2>Send us a message</h2>
          <form>
            <div className="form-group">
              <label htmlFor="name">Full Name</label>
              <input type="text" id="name" placeholder="Your name" required />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input type="email" id="email" placeholder="you@example.com" required />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" rows="5" placeholder="Write your message..." required></textarea>
            </div>

            <button type="submit">Send Message</button>
          </form>
        </div>

        {/* Right: Info + Image */}
        <div className="contact-right">
          <img src={photo} alt="Contact" />
          <div className="contact-info">
            <h3>Get in Touch</h3>
            <p><strong>Email:</strong> info@m2cinternational.com</p>
            <p><strong>Phone:</strong> +1 (747) 777-2758</p>
            <p><strong>Address:</strong> 1317 Edgewater Dr, Orlando, FL 32804, USA</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contact
